export default __webpack_public_path__ + "static/media/coverofdusk.eae27fe6.png";